/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FollowSearchButton_favoritesConnection = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
        } | null;
    } | null> | null;
    readonly " $refType": "FollowSearchButton_favoritesConnection";
};
export type FollowSearchButton_favoritesConnection$data = FollowSearchButton_favoritesConnection;
export type FollowSearchButton_favoritesConnection$key = {
    readonly " $data"?: FollowSearchButton_favoritesConnection$data;
    readonly " $fragmentRefs": FragmentRefs<"FollowSearchButton_favoritesConnection">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "FollowSearchButton_favoritesConnection",
  "type": "favoritesConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "favoritesEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Favorite",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '2f893cfa8da2b1adcbc4e57d7b3984ad';
export default node;
